import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const items = [
  {
    q: "Does Ranq guarantee rankings?",
    a: "No. Ranq does not guarantee rankings, recognitions or band promotions before Chambers & Partners, The Legal 500 or any other legal directory. Ranking decisions belong exclusively to each directory and its research process. Ranq helps firms strengthen what they can control: the quality, structure, consistency and clarity of their submission.",
  },
  {
    q: "What directories does Ranq support?",
    a: "Ranq is built for Chambers & Partners and The Legal 500 submissions. The product is designed around the core sections, methodology and submission logic used by these directories.",
  },
  {
    q: "Can I upload confidential matters through this form?",
    a: "No. The early-access form is for lead qualification only. We do not collect confidential matter details, client names, documents or case information at this stage. Real submission data will only be handled inside the secure product environment, after appropriate privacy and confidentiality safeguards are in place.",
  },
  {
    q: "What will Ranq generate?",
    a: "Ranq produces structured submission drafts, strengthened matter descriptions, aligned lawyer bios and an editable Word (.docx) file your team can review and finalise. It also flags missing or weak information.",
  },
  {
    q: "Is Ranq replacing internal review?",
    a: "No. Ranq is a builder, not a replacement for partner review. Your team always reviews, edits and approves the final submission before filing.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-[#f3efe6]">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-sm uppercase tracking-[0.18em] font-semibold text-stone-500">
            FAQ
          </p>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl tracking-tight font-medium text-stone-900">
            Questions, answered honestly.
          </h2>
        </div>

        <div className="mt-12 rounded-3xl bg-[#f7f4ec] border border-stone-200 px-6 md:px-10">
          <Accordion type="single" collapsible className="w-full">
            {items.map((it, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                data-testid={`faq-item-${idx}`}
                className="border-b border-stone-200 last:border-b-0"
              >
                <AccordionTrigger className="py-6 text-left font-heading text-lg md:text-xl font-medium text-stone-900 hover:text-stone-700 hover:no-underline">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-stone-700 text-base leading-relaxed">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
